const isAbortError = (err) => {
    if (err instanceof DOMException)
        return err.name === "AbortError";
    return false;
};
export const fetchImpl = ({ url, onChunk, onFetchFail, onResponseStart, onFetchSucceed, }) => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const runFetch = async () => {
        const response = await fetch(url, { cache: "no-cache", signal }).catch((err) => {
            if (isAbortError(err))
                return;
            onFetchFail(`Fetch error: ${err.message}`);
        });
        onResponseStart({ timestamp: Date.now() });
        if (!response)
            return onFetchFail("No response");
        if (response.status >= 400)
            return onFetchFail(`Fetch download got unsuccessful HTTP Status: ${response.status}`);
        if (!response.body)
            return onFetchFail("No response body");
        const reader = response.body.getReader();
        while (true) {
            const { done, value } = await reader.read();
            if (done)
                break;
            const timestamp = Date.now();
            const bytes = value.byteLength;
            onChunk({ timestamp, bytes });
        }
        onFetchSucceed({ timestamp: Date.now() });
    };
    runFetch();
    return {
        abort: () => {
            abortController.abort();
        },
    };
};
